module.exports = __webpack_public_path__ + "static/media/earlgreytea.ee7c772e.jpg";